import { useQuery } from '@apollo/client';
import { useRouter } from '@application/utils';
import { graphql } from '@gql/gql';

export const FOOTER_GET_BREEDS = graphql(`
  query FooterGetBreeds(
    $where: DogBreedWhereInput
    $breedCardInfoTranslationsWhere: DogBreedTranslationWhereInput
    $randomOrder: Boolean
  ) {
    findManyDogBreed(where: $where, randomOrder: $randomOrder) {
      id
      name
      baseBreedName
      translations(where: $breedCardInfoTranslationsWhere) {
        id
        name
        url
        language
      }
      _count {
        dogBreeders
        litters
      }
    }
  }
`);

export const useGetInternalLinks = (skip = true) => {
  const { language } = useRouter();

  const { data, error, loading } = useQuery(FOOTER_GET_BREEDS, {
    variables: {
      where: {
        isSubBreed: { equals: false },
        translations: {
          some: {
            AND: [
              { description: { not: { equals: '' } } },
              { description: { not: { equals: null } } },
              { language: { equals: language } },
            ],
          },
        },
        litters: { some: { adminValidated: { equals: true }, archived: { equals: false } } },
      },
      breedCardInfoTranslationsWhere: {
        language: { equals: language },
      },
      randomOrder: true,
    },
    skip,
    fetchPolicy: 'cache-first',
    ssr: false,
  });

  return {
    breeds: data?.findManyDogBreed ?? [],
    breedsError: error,
    breedsLoading: loading,
  };
};
